module.exports = __webpack_public_path__ + "assets/img/zidian.e434803c.png";